<template>
  <div>
    <div class="home"
         @scroll="handleScroll">
      <nav-header />
      <div class="bac"
           :style="backColors">
        <div class="swiper-box">
          <div class="unfold"
               v-if="!messageShow"
               @click="messageShow=true"><i class="el-icon-arrow-left"></i></div>
          <!-- 最新消息 -->
          <div class="nav-menu"
               v-show="messageShow">
            <!-- <div class="pack-up"
               @click="messageShow=false"><i class="el-icon-arrow-right"></i></div> -->
            <div class="box1">
              <div class="avatar">
                <img :src="!userInfo.headPortrait?'/images/default_avatar.png':userInfo.headPortrait"
                     alt="">
              </div>
              <div class="right"
                   v-if="!token">
                <div class="login">请先登录</div>
              </div>
              <div class="right"
                   v-else>
                <span class="name">{{ !userInfo.nickName?'昵称':userInfo.nickName }}</span>
                <button class="btn"
                        :style="'background-color:'+themeColor"
                        @click="logOut">退出</button>
              </div>
            </div>
            <!-- 余额 -->
            <div class="money">
              <div class="box">
                <span class="txt1">福利卡余额</span>
                <span class="txt2">{{ !userInfo.welfarePoint?'0.00':userInfo.welfarePoint }}</span>
              </div>
              <div class="line1"></div>
              <div class="box">
                <span class="txt1">助农卡余额</span>
                <span class="txt2">{{ !userInfo.assistancePoint?'0.00':userInfo.assistancePoint }}</span>
              </div>
            </div>
            <!-- 选项 -->
            <div class="other-box">
              <div class="other_item"
                   @click.stop="jumpCenterPage(1)">
                <img src="/images/home_icon3.png"
                     alt="">
                <div>个人中心</div>
              </div>
              <div class="other_item"
                   @click.stop="jumpCenterPage(2)">
                <img src="/images/home_icon4.png"
                     alt="">
                <div>我的订单</div>
              </div>
              <!-- <div class="other_item"
                 @click.stop="jumpCenterPage(3)">
              <img src="/images/home_icon2.png"
                   alt="">
              <div>福利卡</div>
            </div> -->
              <div class="other_item"
                   @click.stop="jumpCenterPage(4)">
                <img src="/images/home_icon7.png"
                     alt="">
                <div>消息通知</div>
              </div>
              <div class="other_item"
                   @click.stop="jumpCenterPage(5)">
                <img src="/images/home_icon5.png"
                     alt="">
                <div>我的收藏</div>
              </div>
              <div class="other_item"
                   @click.stop="jumpCenterPage(6)">
                <img src="/images/home_icon6.png"
                     alt="">
                <div>浏览记录</div>
              </div>
            </div>
            <div class="line"></div>
            <div class="box2">
              <div class="nav">
                <span style="font-size: 14px;">最新公告</span>
                <div style="display: flex;align-items: center;"
                     @click="jumpNotice">
                  <span style="color: #999999;">更多</span>
                  <img src="/images/right_gray.png"
                       alt=""
                       style="width: 12px;height: 12px;">
                </div>
              </div>
              <div class="center">
                <div class="message"
                     v-for="(item,index1) in noticeList1"
                     :key="index1"
                     v-show="index1==0">
                  <span class="word"><span class="lable">最新</span>{{ item.title }}</span>
                </div>
                <!-- <div class="message">
              <span class="word2"
                    v-for="(item,index2) in noticeList2"
                    :key="index2">{{ item.title }}</span>
            </div> -->
              </div>
            </div>
          </div>
          <!-- 活动列表 -->
          <div class="activityList">
            <swiper class="swiper"
                    :options="swiperActOption"
                    v-if="activityList.length">
              <swiper-slide v-for="(item,index) in activityList"
                            :key="index">
                <div class="activityItem">
                  <div class="activity_img"
                       @click="jumpActivityGroup(item)">
                    <img :src="item.mainImg"
                         :data-v='JSON.stringify(item)'
                         alt=""
                         style="width: 100%;height: 194px;border-radius: 10px;">
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <!-- 轮播图 -->
          <div class="swiper">
            <swiper class="swiper-container"
                    :options="swiperOption">
              <swiper-slide v-for="(item,index) in swiperList"
                            :key="index">
                <img :src="item.picUrl"
                     alt="">
              </swiper-slide>
              <div class="swiper-pagination"
                   slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <div class="goodsList">
          <!-- 蛋糕专区、电影专区 -->
          <div class="module">
            <div class="module_item">
              <img src="/images/cake_img2.png"
                   alt=""
                   class="module_img">
              <div class="right">
                <div class="top">
                  <div class="title">热卖推荐</div>
                  <div class="more"
                       @click.stop="jumpModule(1)">
                    <span>全部</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="cake">
                  <div style="display: flex;justify-content: center;"
                       v-for="(item,index) in cakeList"
                       :key="index"
                       @click.stop="jumpCakeDetail(item)">
                    <div class="item">
                      <img :src="item.picUrl"
                           alt=""
                           class="img">
                      <div class="info">
                        <div class="name">{{ item.name }}</div>
                        <div class="box">
                          <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                          <div class="num">已售{{ item.salesCount }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="module_item">
              <img src="/images/movie_img2.png"
                   alt=""
                   class="module_img">
              <div class="right">
                <div class="top">
                  <div class="title">正在热映</div>
                  <div class="more"
                       @click.stop="jumpModule(2)">
                    <span>全部</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>
                <div class="movie">
                  <div style="display: flex;justify-content: center;"
                       v-for="(item,index) in movieList"
                       :key="index"
                       @click.stop="jumpMovieDetail(item)">
                    <div class="item">
                      <div class="img_box">
                        <img :src="item.pic"
                             class="img"
                             alt="">
                        <div class="box">
                          <div class="name">{{ item.filmName }}</div>
                          <div class="rate">{{ Number(item.score).toFixed(1) }}</div>
                        </div>
                      </div>
                      <div class="foot">购票</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 优惠专区 -->
          <discountModule></discountModule>
          <!-- 新品推荐 -->
          <div v-if="newGoodsList.length != 0&&false">
            <div class="navBar">
              <div class="title"
                   :style="'color:'+fontsColor">新品推荐</div>
              <div style="display: flex;align-items: center;"
                   @click="jumpGoodsList('','new')">
                <span :style="'color:'+txtColor">更多</span>
                <i class="el-icon-arrow-right"
                   :style="'font-size:18px;color:'+txtColor"></i>
              </div>
            </div>
            <vue-seamless-scroll :data="newGoodsList"
                                 :class-option="classOption"
                                 class="warp">
              <ul class="ul-item">
                <li class="li-item"
                    v-for="(item, index) in newGoodsList"
                    :key="index"
                    @click="jumpDetail(item,1)">
                  <img :src="item.picUrl"
                       alt=""
                       style="width: 100%;height: 164px;">
                  <div class="info">
                    <div class="name">{{ item.name }}</div>
                    <div class="box">
                      <span class="price">￥{{ (Number(item.price)/100).toFixed(2) }}</span>
                      <span class="num">已售{{ item.salesCount }}</span>
                    </div>
                  </div>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
          <!-- 模块管理 -->
          <div style="margin-top: 40px;">
            <modulPage></modulPage>
          </div>
          <!-- 品牌 -->
          <div v-if="brandList.length!=0||JSON.stringify(brandFirst) != '{}'">
            <div class="top-bac">
              <img src="/images/brand_bac.png"
                   alt="">
            </div>
            <div class="navBar">
              <div class="title"
                   :style="'color:'+fontsColor">品牌直达</div>
              <div style="display: flex;align-items: center;"
                   @click="jumpBrand">
                <span :style="'color:'+txtColor">更多</span>
                <i class="el-icon-arrow-right"
                   :style="'font-size:18px;color:'+txtColor"></i>
              </div>
            </div>
            <div class="brand">
              <ul class="list">
                <div class="left"
                     v-if="JSON.stringify(brandFirst) != '{}'"
                     @click="jumpGoodsList(brandFirst,'')">
                  <img :src="!brandFirst.picUrl?'':brandFirst.picUrl"
                       alt="">
                  <span>{{ brandFirst.name }}</span>
                </div>
                <div class="right">
                  <li class="brand_box"
                      v-for="(item, index) in brandList"
                      :key="index"
                      @click="jumpGoodsList(item,'')">
                    <div class="item">
                      <img :src="!item.picUrl?'':item.picUrl"
                           alt="">
                      <span class="name">{{ item.name }}</span>
                    </div>
                  </li>
                </div>
              </ul>
            </div>
          </div>
          <!-- 分组选择 -->
          <div :class="!isFixed?'tianchong':'tabsBox'"
               v-if="isFixed"></div>
          <div :class="!isFixed?'noFixed':'fixed'">
            <div class="tabsBox"
                 v-if="groupList.length">
              <div class="tabs"
                   v-for="(item, index) in groupList"
                   :key="index"
                   @click="tabClick(item,index)">
                <div class="item "
                     :class="{active:tabIndex==index}">
                  <div class="name">{{ item.name }}</div>
                  <div class="word">{{ item.nameSub }}</div>
                </div>
                <div class="line"
                     v-if="index!=groupList.length-1"></div>
              </div>
            </div>
          </div>
          <!-- 分组商品 -->
          <div class="groupGoods"
               style="margin-top: 40px;">
            <div class="goods"
                 style="margin-top: 10px;">
              <ul class="list">
                <li class="goods_box"
                    v-for="(item, index) in goodsList"
                    :key="index"
                    @click="jumpDetail(item,1)">
                  <div class="item">
                    <div class="img">
                      <img :src="item.picUrl"
                           alt="">
                      <div class="mask"
                           v-if="item.isInStock == false">当前地址无货</div>
                    </div>
                    <div class="info">
                      <div class="name">{{ item.name }}</div>
                      <div class="num">已售{{ item.salesCount }}</div>
                      <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                    </div>
                  </div>
                </li>
              </ul>
              <div style="width: 100%;height: 200px;display: flex;justify-content: center;"
                   v-if="goodsList.length==0">
                <el-empty description=" "></el-empty>
              </div>
            </div>
          </div>
          <!-- 热门推荐 -->
          <div v-if="hotGoodsList.length != 0&&false">
            <div class="navBar">
              <div class="title"
                   :style="'color:'+fontsColor">热门推荐</div>
              <div style="display: flex;align-items: center;"
                   @click="jumpGoodsList('','hot')">
                <span :style="'color:'+txtColor">更多</span>
                <i class="el-icon-arrow-right"
                   :style="'font-size:18px;color:'+txtColor"></i>
              </div>
            </div>
            <div class="goods"
                 style="margin-top: 10px;">
              <ul class="list">
                <li class="goods_box"
                    v-for="(item, index) in hotGoodsList"
                    :key="index"
                    @click="jumpDetail(item,1)">
                  <div class="item">
                    <div class="img">
                      <img :src="item.picUrl"
                           alt="">
                      <div class="mask"
                           v-if="item.isInStock == false">当前地址无货</div>
                    </div>
                    <div class="info">
                      <div class="name">{{ item.name }}</div>
                      <div class="num">已售{{ item.salesCount }}</div>
                      <div class="price"><span>￥</span>{{ (Number(item.price)/100).toFixed(2) }}</div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <nav-footer />

      <!-- 视频飘窗 -->
      <!-- <Baywindow ref="windowChild"
                 v-if="floatStatus"
                 :show="floatStatus"
                 @click="clear"></Baywindow> -->

    </div>
  </div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll'
import Baywindow from "@/components/BayWindow.vue";
import modulPage from './HomePage/components/modulPage.vue';
import discountModule from './DiscountPage/DiscountModule.vue'
import NavHeader from '@/components/NavHeader.vue';
import NavFooter from '@/components/NavFooter.vue';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapState } from 'vuex';
export default {
  name: 'index',
  components: { NavHeader, NavFooter, Swiper, SwiperSlide, vueSeamlessScroll, Baywindow, modulPage, discountModule },
  data () {
    return {
      showModal: false,
      swiperOption: {
        autoplay: {
          delay: 5000,
        },
        loop: true,
        loopedSlides: 3,
        pagination: {
          el: '.swiper-pagination',
          clickable: false
        },
      },
      swiperActOption: {
        loop: true,
        autoplay: {
          delay: 5000,
        },
        slidesPerView: 4,
        spaceBetween: 40,
        observer: true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        on: {
          click: (event) => {
            if (event.target.getAttribute('data-v')) {
              // 这里的 obj 就是当前点击图片所对应的信息
              let obj = JSON.parse(event.target.getAttribute('data-v'))
              console.log(obj);
              this.jumpActivityGroup(obj)
            }
          }
        }
      },
      swiperList: [],
      page: 1,
      newGoodsList: [],//新品
      classOption: {
        limitMoveNum: 7,
        direction: 2,
      },
      tabIndex: 0,
      brandFirst: {},
      brandList: [],//置顶品牌
      companyList: [],//活动列表
      activityList: [],
      hotGoodsList: [],//热门推荐
      noticeList1: [],//最新通知
      noticeList2: [],
      userInfo: {},//个人信息
      cakeList: [],//蛋糕
      groupList: [],//分组列表
      goodsList: [],//商品列表
      pageNum: 1,
      isBottom: false,
      isFixed: false,
      movieList: [],
      token: '',
      messageShow: true
    };
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);

    this.token = localStorage.getItem('wckj-Token')
    this.$loading()
    this.getSwiper()
    if (localStorage.getItem('wckj-Token')) {
      // this.getActivity()
      this.getUserInfo()
    }
    this.getNewGoodsList()
    this.getTopBrand()
    this.getHotGoods()
    this.getNotice()
    this.getActivityList()
    this.getCakeList()
    this.getMovieList()
    this.getIndexGroupList()
  },
  created () {
    if (this.cakeCityId) {
      this.getCakeList()
    }
    // this.$store.dispatch('saveFloatStatus', true)
  },
  watch: {
    cakeCityId (newValue, oldValue) {
      console.log(newValue, oldValue);
      if (newValue != oldValue) {
        this.getCakeList()
      }
    },
    movieCityId (newValue, oldValue) {
      if (newValue != oldValue) {
        this.getMovieList()
      }
    }
  },
  computed: {
    ...mapState(['cakeCityId', 'cakeCityName', 'movieCityName', 'movieCityId', 'floatStatus', 'backColors', 'fontsColor', 'txtColor', 'themeColor'])
  },
  methods: {
    clear () {
      console.log('清除定时器');
    },
    handleScroll () {
      // 在滚动时执行的操作
      // console.log("页面滚动事件被触发了", window.scrollY);
    },
    // 选择分组
    tabClick (item, index) {
      if (this.tabIndex == index) {
        return
      }
      this.isBottom = true
      this.tabIndex = index
      this.pageNum = 1
      this.goodsList = []
      this.$forceUpdate()
      this.$loading()
      this.getIndexGroupProduct(item.id, 1)
    },
    jumpCenterPage (type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveMessageType', '')
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/userInfo');
      } else if (type == 2) {
        this.$store.dispatch('savePersonType', 1)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/orderList');
      } else if (type == 3) {
        this.$store.dispatch('savePersonType', 3)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/benefitCard');
      } else if (type == 4) {
        this.$store.dispatch('saveMessageType', 1)
        this.$store.dispatch('savePersonType', '')
        this.$router.push('/messageList');
      } else if (type == 5) {
        this.$store.dispatch('savePersonType', 9)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/collectRecord');
      } else if (type == 6) {
        this.$store.dispatch('savePersonType', 10)
        this.$store.dispatch('saveMessageType', '')
        this.$router.push('/browseRecord');
      }
    },
    // 跳转更多信息
    jumpNotice () {
      this.$router.push('/noticeList')
    },
    // 去购物车
    goCart () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push('/cart');
    },
    // 更多品牌
    jumpBrand () {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$router.push('/brandList')
    },
    // 跳转模块
    jumpModule (type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (type == 1) {
        this.$store.dispatch('saveCakeParams', '')
        this.$router.push('/cakeList')
      } else {
        this.$store.dispatch('saveMovieInfo', {})
        this.$router.push('/movieZone')
      }
    },
    // 跳转蛋糕详情
    jumpCakeDetail (item) {
      this.$store.dispatch('saveGoodsId', item.id)
      this.$store.dispatch('saveModeType', 1)
      this.$router.push({
        name: "cakeDetail",
      });
    },
    // 跳转电影详情
    jumpMovieDetail (item) {
      this.$router.push({
        path: '/movieZoneDetail',
        query: {
          id: item.filmId,
          type: 1//1：电影 2：影院
        }
      })
    },
    // 跳转详情
    jumpDetail (item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.productType == 1) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "jdDetail",
        });
      }else if (item.productType == 2) {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$router.push({
          name: "cakeDetail",
        });
      } else {
        this.$store.dispatch('saveGoodsId', item.id)
        this.$store.dispatch('saveModeType', 1)
        this.$store.dispatch('saveCategoryTitle', '')
        this.$router.push({
          name: "detail",
        });
      }
    },
    // 跳转商品列表
    jumpGoodsList (item, type) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      var title = ''
      if (type == 'new') {
        title = '新品推荐'
      } else if (type == 'hot') {
        title = '热门推荐'
      } else {
        title = item.name
      }
      this.$store.dispatch('saveCategoryTitle', title)
      this.$store.dispatch('saveRecommendType', type)
      this.$store.dispatch('saveBrandId', item.id)
      this.$store.dispatch('saveCategoryId', '')
      this.$store.dispatch('saveWebGoodsInfo', '')
      this.$router.push({
        name: "goodsList",
      });
    },
    // 跳转活动商品列表
    jumpActivityList (item) {
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      this.$store.dispatch('saveActivityId', item.id)
      this.$router.push({
        name: "activityList",
      });
    },
    // 跳转活动分组列表
    jumpActivityGroup (item) {
      console.log(item);
      if (!localStorage.getItem('wckj-Token')) {
        this.$message({
          message: '请先登录',
          type: 'warning'
        });
        this.$router.push('/login')
        return
      }
      if (item.isPreview == 1) {
        this.$message.warning('敬请期待！')
      } else {
        this.$store.dispatch('saveActivityId', item.id)
        this.$router.push({
          name: "activityGroup",
        });
      }
    },
    // 退出登录
    logOut () {
      this.$confirm('确认退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: '退出成功!'
        });
        this.$router.push('/login')
        localStorage.removeItem('wckj-Token')
        this.$store.dispatch('saveToken', '');
      }).catch(() => {
        console.log('取消');
      });
    },
    // 获取轮播图
    async getSwiper () {
      await this.$api.mall.getSwiper({
        position: 11
      }).then((res) => {
        console.log(res, '轮播图');
        if (res.code == 200) {
          this.swiperList = res.data
          console.log(this.swiperList, 675);

        }
      });
    },
    // 获取蛋糕列表
    getCakeList () {
      this.$api.mall.getGoodsList({
        pageSize: 6,
        pageNum: 1,
        recommendType: 'cake',
        cityId: this.cakeCityId
      }).then((res) => {
        console.log(res, '蛋糕');
        if (res.code == 200) {
          let data = !res.rows ? [] : res.rows
          this.cakeList = data
        }
      });
    },
    // 获取电影列表
    getMovieList () {
      this.$api.mall.getMovieHome({
        hotNum: 6,
        soonNum: 0,
        thirdDNum: 0,
        recommendNum: 0,
        topNum: 0,
      }).then(res => {
        console.log(res);
        if (res.code == 200) {
          let data = res.data
          this.movieList = !data.hot.rows ? [] : data.hot.rows
        }
      })
    },
    // 获取新品商品列表
    async getNewGoodsList () {
      await this.$api.mall.getGoodsList({
        pageSize: 10,
        pageNum: 1,
        recommendType: 'new'
      }).then((res) => {
        console.log(res, '新品');
        if (res.code == 200) {
          let list = !res.rows ? [] : res.rows
          // if (list.length < 3) {
          //   this.newGoodsList = [...list, ...list]
          // } else {
          //   this.newGoodsList = list
          // }
          this.newGoodsList = list
          console.log(this.newGoodsList, 447);
        }
      });
    },
    // 获取品牌
    async getTopBrand () {
      await this.$api.mall.getTopBrand().then((res) => {
        console.log(res, '品牌');
        if (res.code == 200) {
          let data = res.data
          if (data.length != 0) {
            this.brandFirst = data[0]
            data.splice(0, 1)
            this.brandList = res.data
          }
        }
      });
    },
    // 获取活动
    async getActivity () {
      await this.$api.mall.getCompanyActivity().then((res) => {
        console.log(res, '活动');
        if (res.code == 200) {
          if (res.data) {
            let data = res.data
            this.companyList = data
            data.forEach((item, index) => {
              let ids = item.productIds.join(',')
              console.log(ids);
              this.getActivityGoods(ids, index)
            })
          }
        }
      });
    },
    // 获取活动列表
    getActivityList () {
      this.$api.mall.getActivityList().then((res) => {
        console.log(res, '活动列表')
        if (res.code == 200) {
          this.activityList = res.data
        }
      })
    },
    // 获取活动商品
    async getActivityGoods (ids, index) {
      await this.$api.mall.getListByIds({
        ids: String(ids)
      }).then((res) => {
        console.log(res, '活动商品');
        if (res.code == 200) {
          let list = !res.data ? [] : res.data
          console.log(list);
          if (list.length < 14) {
            this.companyList[index].activityList = list
            console.log(this.companyList[index].activityList, 447);
          } else {
            let activityList = []
            list.forEach((item, index) => {
              if (index < 14) {
                activityList.push(item)
              }
            });
            this.companyList[index].activityList = activityList
          }
        }
        this.$forceUpdate()
      });
    },
    // 获取分组列表
    getIndexGroupList () {
      this.$api.mall.getIndexGroupList().then(res => {
        console.log(res, '分组列表');
        if (res.code == 200) {
          this.groupList = !res.data ? [] : res.data
          if (res.data.length) {
            this.isBottom = true
            this.getIndexGroupProduct(res.data[0].id, 2)
          }
        }
      });
    },
    // 获取商品列表
    getIndexGroupProduct (id, type) {
      if (!this.isBottom) return
      this.isBottom = false
      this.$api.mall.getIndexGroupProduct({
        id: id,
        pageNum: this.pageNum,
        pageSize: 21
      }).then(res => {
        console.log(res, '商品列表');
        if (res.code == 200) {
          let data = !res.data.rows ? [] : res.data.rows
          this.goodsList = this.pageNum == 1 ? data : [...this.goodsList, ...data]
        }
        if (type == 1) {
          this.$loading().close()
        }
      });
    },
    // 获取热门推荐
    async getHotGoods () {
      await this.$api.mall.getGoods({
        recommendType: 'hot',
        count: 21
      }).then((res) => {
        console.log(res, '热门推荐');
        if (res.code == 200) {
          this.hotGoodsList = !res.data ? [] : res.data
        }
      });
    },
    // 获取最新公告
    async getNotice () {
      await this.$api.mall.getNotice({
        releasePc: 1
      }).then((res) => {
        console.log(res, '最新公告');
        if (res.code == 200) {
          let data = res.data
          if (data.lenth <= 3) {
            this.noticeList1 = data
          } else {
            data.forEach((item, index) => {
              if (index < 3) {
                this.noticeList1.push(item)
              } else {
                this.noticeList2.push(item)
              }
            })
          }
        }
      });
    },
    // 获取个人信息
    async getUserInfo () {
      await this.$api.mall.getInfo().then((res) => {
        console.log(res, '个人信息');
        if (res.code == 200) {
          this.userInfo = res.data.userInfo
        }
      });
    },
    handleScroll () {
      const scrollOffset = document.querySelector('.home').scrollTop
      const tabs = document.querySelector('.tabsBox')//需要固定的元素
      // 获取所需元素到文档顶部的距离
      const offsetTop = tabs.offsetTop
      // 然后判断滚动条位置让该元素是否固定定位
      if (scrollOffset >= offsetTop) {
        // console.log('到底了！！！！！');
        this.isFixed = true
      } else {
        // console.log('滚动到顶部了！！！！！');
        this.isFixed = false
      }

      const contentContainer = document.querySelector('.home');
      const { scrollTop, offsetHeight, scrollHeight } = contentContainer;
      const distanceFromBottom = scrollHeight - (scrollTop + offsetHeight);
      // console.log(distanceFromBottom);

      if (distanceFromBottom < 1 && distanceFromBottom > -1) {
        this.isBottom = true
        this.pageNum++
        this.$loading()
        this.getIndexGroupProduct(this.groupList[this.tabIndex].id, 1)
      }
    }
  }
};
</script>

<style lang='scss' scoped>
.home {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  cursor: pointer;
  .bac {
    width: 100%;
  }
  .swiper-box {
    width: 100%;
    position: relative;
    .unfold {
      width: 25px;
      height: 50px;
      background-color: #fff;
      box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
      position: absolute;
      right: 0;
      top: calc(50% - 25px);
      z-index: 8;
      font-size: 22px;
      border-radius: 30px 0 0 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .nav-menu {
      position: absolute;
      right: 200px;
      top: 20px; /*no*/
      width: 210px;
      opacity: 1;
      height: 400px; /*no*/
      z-index: 9;
      padding: 24px 10px 20px;
      background: #ffffff;
      box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
      box-sizing: border-box;
      transition: show 0.5s;
      .pack-up {
        width: 25px;
        height: 50px;
        background-color: #fff;
        position: absolute;
        left: -25px;
        top: calc(50% - 25px);
        z-index: 5;
        font-size: 22px;
        border-radius: 30px 0 0 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .box1 {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .avatar {
          width: 54px;
          height: 54px;
          border-radius: 100%;
          overflow: hidden;
          img {
            width: 54px;
            height: 54px;
            display: inline-block;
          }
        }
        .right {
          flex: 1;
          height: 54px;
          padding-left: 12px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .name {
            width: 100%;
            font-size: 12px;
          }
          .btn {
            width: 58px;
            height: 26px;
            background-color: #004098;
            border-radius: 13px;
            text-align: center;
            line-height: 26px;
            font-size: 12px;
            color: #fff;
          }
          .login {
            line-height: 54px;
          }
        }
      }
      .money {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 0;
        box-sizing: border-box;
        .box {
          flex: 1;
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          .txt1 {
            font-size: 12px;
          }
          .txt2 {
            display: inline-block;
            height: 25px;
            font-size: 14px;
            color: #ff0000;
            font-weight: bold;
            line-height: 25px;
          }
        }
        .line1 {
          width: 0.5px;
          height: 30px;
          border-left: 1px dashed #cccccc;
        }
      }
      .other-box {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(auto-fill, 33.33%);
        justify-content: space-between;
        grid-row-gap: 10px;
        // margin-top: 20px;
        .other_item {
          width: 100%;
          height: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          img {
            width: 24px;
            height: 24px;
          }
          div {
            font-size: 12px;
            line-height: 35px;
          }
        }
      }
      .line {
        width: 100%;
        height: 1px;
        border-top: 1px dashed #707070;
        margin: 15px 0;
      }
      .box2 {
        width: 100%;
        .nav {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .center {
          width: 100%;
          margin-top: 10px;
          .message {
            width: 100%;
            // display: flex;
            // align-items: center;
            // justify-content: flex-start;
            margin-top: 8px;
            .lable {
              display: inline-block;
              width: 32px;
              height: 18px;
              background-color: #f8e8eb;
              text-align: center;
              line-height: 18px;
              font-size: 12px;
              color: #e60012;
            }
            .word {
              flex: 1;
              display: inline-block;
              font-size: 14px;
              margin-top: 5px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }
            .word:first-child {
              margin-top: 0;
            }
            .word2 {
              flex: 1;
              display: inline-block;
              font-size: 12px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 12;
              -webkit-box-orient: vertical;
              word-break: break-all;
            }
          }
          .message:first-child {
            margin-top: 0;
          }
        }
      }
    }
    .activityList {
      width: 100%;
      display: flex;
      padding: 0 200px;
      box-sizing: border-box;
      position: absolute;
      bottom: -80px;
      left: 0;
      z-index: 20;
      .activityItem {
        width: 345px;
        .activity_img {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
    .swiper {
      width: 100%;
      padding: 0;
      box-sizing: border-box;
      // background-color: #f5f5f5;
      .swiper-container {
        width: 100%;
        height: 680px; /*no*/

        img {
          width: 100%;
          height: 680px; /*no*/
        }
      }
      ::v-deep .swiper-pagination-bullet {
        background: #eeeeee !important;
      }
      ::v-deep .swiper-pagination-bullet-active {
        background: #ffffff !important;
      }
    }
  }
  .goodsList {
    width: 100%;
    min-height: 500px;
    // background-color: #f5f5f5;
    padding: 100px 200px 50px;
    box-sizing: border-box;
    .activityList {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 30px;
      .activityItem {
        width: 345px;
        .activity_img {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
    .navBar {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0 20px;
      box-sizing: border-box;
      margin-top: 25px;
      .title {
        font-size: 32px;
        font-weight: bold;
      }
      span {
        font-size: 20px;
      }
    }
    .module {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 20px;
      .module_item {
        width: 735px;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 10px;
        box-sizing: border-box;
        border: 1px solid #fdecdf;
        border-radius: 3px;
        .module_img {
          width: 200px;
          height: 483px;
          display: inline-block;
        }
        .right {
          flex: 1;
          height: 470px;
          margin-left: 10px;
          .top {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px;
            box-sizing: border-box;
            .title {
              font-size: 17px;
              color: #ea4149;
              font-weight: bold;
            }
            .more {
              display: flex;
              align-items: center;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .cake {
            width: 100%;
            height: 420px;
            display: grid;
            grid-template-columns: repeat(auto-fill, 33.33%);
            justify-content: space-between;
            grid-row-gap: 20px;
            margin-top: 30px;

            .item {
              width: 150px;
              box-sizing: border-box;
              background-color: #ffffff;
              box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
              .img {
                width: 150px;
                height: 150px;
                display: inline-block;
              }
              .info {
                width: 150px;
                // height: 60px;
                background-color: #fff;
                padding: 5px 10px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-radius: 0 0 8px 8px;
                .name {
                  width: 100%;
                  height: 22px;
                  font-size: 14px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-all;
                }
                .box {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  .price {
                    font-size: 14px;
                    color: #ff0000;
                  }
                  .num {
                    font-size: 12px;
                    color: #999999;
                  }
                }
              }
            }
          }
          .movie {
            width: 100%;
            height: 428px;
            display: grid;
            grid-template-columns: repeat(auto-fill, 33.33%);
            justify-content: space-between;
            grid-row-gap: 20px;
            margin-top: 30px;
            .item {
              width: 140px;
              box-sizing: border-box;
              background-color: #ffffff;
              box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
              .img_box {
                width: 140px;
                height: 170px;
                position: relative;
                .img {
                  width: 140px;
                  height: 170px;
                  display: inline-block;
                }
                .box {
                  width: 140px;
                  background-color: rgba(0, 0, 0, 0.4);
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 5px;
                  box-sizing: border-box;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                  .name {
                    flex: 1;
                    font-size: 12px;
                    color: #fff;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                  }
                  .rate {
                    font-size: 14px;
                    color: #ff8c00;
                  }
                }
              }
              .foot {
                width: 100%;
                height: 30px;
                text-align: center;
                line-height: 35px;
                color: #ff0000;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
    .warp {
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
      ul {
        list-style: none;
        padding: 10px 0;
        margin: 0 auto;
        &.ul-item {
          display: flex;
          .li-item {
            width: 204px;
            box-sizing: border-box;
            margin-right: 20px;
            background-color: #ffffff;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            img {
              display: inline-block;
              border-radius: 8px 8px 0 0;
            }
            .info {
              width: 204px;
              height: 88px;
              background-color: #fff;
              padding: 10px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              border-radius: 0 0 8px 8px;
              .name {
                width: 100%;
                height: 36px;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }
              .box {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .price {
                  font-size: 14px;
                  color: #ff0000;
                }
                .num {
                  font-size: 12px;
                  color: #999999;
                }
              }
            }
          }
        }
      }
    }
    .classify_box1 {
      width: 100%;
      display: flex;
      justify-content: space-between;
      margin-top: 30px;
      .box1 {
        // width: 50%;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        .left {
          width: 160px;
          height: 270px;
          display: flex;
          flex-direction: column;
          align-items: center;
          box-sizing: border-box;
          background-color: #fff;
          box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          img {
            display: block;
            width: 160px;
            height: 190px;
            border-radius: 0 0 8px 8px;
          }
          .name {
            flex: 1;
            font-size: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .right {
          flex: 1;
          height: 270px;
          margin-left: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-content: space-between;
          .item {
            background-color: #ffffff;
            border-radius: 4px;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
            img {
              display: block;
              width: 100px;
              height: 100px;
              border-radius: 4px 4px 0 0;
            }
            .name {
              height: 30px;
              font-size: 14px;
              color: #999;
              text-align: center;
              line-height: 30px;
            }
          }
          .login {
            font-size: 14px;
            color: #ff0000;
          }
        }
      }
    }
    .classify_box2 {
      width: 100%;
      margin-top: 20px;
      display: grid;
      grid-template-columns: repeat(auto-fill, 14.3%);
      justify-content: space-between;
      grid-row-gap: 20px;
      .box {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        .item {
          width: 160px;
          background-color: #fff;
          box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
          border-radius: 8px;
          img {
            display: block;
            width: 160px;
            height: 160px;
            border-radius: 8px 8px 0 0;
          }
          .name {
            width: 100%;
            height: 30px;
            text-align: center;
            line-height: 30px;
          }
        }
      }
    }
    .brand {
      width: 100%;
      margin-top: 10px;
      .list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 0;
        .left {
          width: 200px;
          height: 420px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          background-color: #fff;
          box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
          img {
            width: 200px;
            height: 200px;

            border: none;
          }
          span {
            display: inline-block;
            width: 100%;
            line-height: 30px;
            text-align: center;
          }
        }
        .right {
          flex: 1;
          height: 420px;
          margin-left: 20px;
          // display: grid;
          // grid-template-columns: repeat(auto-fill, 25%);
          // justify-content: space-between;
          display: flex;
          justify-content: flex-start;
          align-content: flex-start;
          flex-wrap: wrap;
          .brand_box {
            display: flex;
            margin: 0 20px 20px 0;
            .item {
              width: 200px;
              border-radius: 4px;
              position: relative;
              img {
                width: 200px;
                height: 200px;
                border-radius: 8px;
                box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
              }
              .name {
                display: inline-block;
                width: 200px;
                position: absolute;
                bottom: 0;
                left: 0;
                z-index: 1;
                text-align: center;
                line-height: 30px;
                background-color: rgba(255, 255, 255, 0.9);
                // color: #;
                border-radius: 0 0 4px 4px;
              }
            }
          }
          .brand_box:nth-child(6n) {
            margin-right: 0;
          }
        }
      }
    }
    .top-bac {
      width: 100%;
      height: 120px;
      border-radius: 12px;
      margin-top: 40px;
      img {
        width: 100%;
        height: 120px;
        border-radius: 12px;
        display: inline-block;
      }
    }
    .goods {
      width: 100%;
      margin-top: 30px;
      .list {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-content: flex-start;
        flex-wrap: wrap;
        padding-left: 0;
        .goods_box {
          width: 201px;
          display: flex;
          justify-content: center;
          margin: 0 15px 20px 0;
          .item {
            width: 201px;
            border-radius: 4px;
            background-color: #fff;
            box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
            .img {
              width: 201px;
              height: 201px;
              position: relative;
              img {
                width: 201px;
                height: 201px;
                display: block;
                border-radius: 4px;
              }
              .mask {
                width: 201px;
                height: 30px;
                position: absolute;
                bottom: 0;
                left: 0;
                z-index: 2;
                background-color: rgba(0, 0, 0, 0.5);
                border-radius: 0 0 8px 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;
                color: #fff;
                font-weight: bold;
              }
            }
            .info {
              width: 201px;
              height: 88px;
              background-color: #fff;
              padding: 10px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              border-radius: 0 0 8px 8px;
              .name {
                width: 100%;
                font-size: 14px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                word-break: break-all;
              }
              .num {
                width: 100%;
                text-align: center;
                font-size: 12px;
                color: #999999;
              }
              .price {
                width: 100%;
                font-size: 16px;
                color: #e60012;
                text-align: center;
                span {
                  font-size: 10px;
                }
              }
            }
          }
        }
        .goods_box:nth-child(7n) {
          margin-right: 0;
        }
      }
    }
    .tianchong {
      width: 100%;
      height: 80px;
      margin-top: 30px;
    }
    .fixed {
      width: 100%;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 30;
      padding: 0 220px 0 200px;
      box-sizing: border-box;
    }
    .noFixed {
      width: 100%;
      margin-top: 30px;
    }
    .tabsBox {
      width: 100%;
      height: 80px;
      box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.05);
      background-color: #fff;
      padding: 10px 120px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tabs {
        flex: 1;
        height: 100%;
        display: flex;
        align-items: center;
        .item {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .name {
            width: 120px;
            height: 30px;
            border-radius: 20px;
            text-align: center;
            line-height: 30px;
            font-size: 16px;
            font-weight: bold;
          }
          .word {
            line-height: 25px;
            color: #999;
            font-size: 14px;
          }
        }
        .active {
          .name {
            background-color: #e60012;
            color: #fff;
          }
          .word {
            color: #e60012;
          }
        }
        .line {
          width: 2px;
          height: 50px;
          border-left: 1px solid #ddd;
        }
      }
    }
  }
  .ads-box {
    @include flex();
    margin-top: 14px;
    margin-bottom: 31px;
    a {
      width: 296px;
      height: 167px;
    }
  }
}
</style>